import { DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { DateFormat, IDatePickerWithFormat } from 'src/pages/observers/components/DatePickerWithFormat/types';

export default function DatePickerWithFormat(
	{
		onDateChange,
		size = 'middle',
	}: IDatePickerWithFormat
) {
	const [ format, setFormat, ] = useState<DateFormat>('DD-MM-YYYY');

	return (
		<DatePicker
			style={{ width: '100%', }}
			size={size}
			format={format}
			onChange={(d: Date) =>
				onDateChange(d ? dayjs(d).format(format) : null)
			}
			renderExtraFooter={() => 
				<Select
					variant='borderless'
					placeholder='Selecione o formato da data'
					style={{ width: '100%', }}
					size='small'
					value={format}
					onChange={(value) => setFormat(value)}
					options={[
						'YYYY-MM-DD',
						'YYYY-MM-DD HH:mm:ss',
						'YYYY-MM-DD HH:mm:ss.SSS',
						'YYYY-MM-DDTHH:mm:ssZ',
						'YYYY-MM-DDTHH:mm:ss.SSSZ',
						'MM-DD-YYYY',
						'DD-MM-YYYY',
						'DD/MM/YYYY',
						'MM/DD/YYYY',
						'YYYY/MM/DD',
						'DD-MM-YYYY HH:mm:ss',
						'MM-DD-YYYY HH:mm:ss',
						'MM/DD/YYYY HH:mm:ss',
						'DD/MM/YYYY HH:mm:ss',
						'unix_timestamp',
						'x',
						'ddd, MMM DD YYYY HH:mm:ss',
						'MMMM DD, YYYY',
						'MMM DD, YYYY',
						'YYYYMMDD',
						'YYYYMMDDHHmmss',
						'HH:mm:ss',
						'HH:mm',
						'hh:mm A',
						'hh:mm:ss A',
						'HHmmss',
						'DDMMYYYY',
						'MMDDYYYY',
						'YYMMDD',
						'YYYY-MM-DDTHH:mm:ss.sssZ',
						'YYYY-MM',
						'YYYY',
						'MM-DD',
						'MMM YYYY',
						'MMMM YYYY',
						'Q YYYY',
						'GGGG-[W]WW',
						'GGGG-[W]WW-E',
					].map(value => ({ value, label: value, }))}
				/>
			}
		/>
	);
}
